// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zDcaQ","index":"styles_index__3cKt-"};